import { PropsWithoutRef } from 'react'

import Icon from '@ant-design/icons'
import { type IconBaseProps } from '@ant-design/icons/lib/components/Icon'

import { WpsUndoSvg } from './WpsUndoSvg'

export const WpsUndoIcon = (props: PropsWithoutRef<IconBaseProps>) => {
  return <Icon component={WpsUndoSvg} {...props} />
}
